import { render } from "./emulatorDebugger.vue?vue&type=template&id=52befcd2&scoped=true"
import script from "./emulatorDebugger.vue?vue&type=script&lang=js"
export * from "./emulatorDebugger.vue?vue&type=script&lang=js"

import "./emulatorDebugger.vue?vue&type=style&index=0&id=52befcd2&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52befcd2"]])

export default __exports__